@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins; 
  display: block;
}

.content-left {
  @apply text-start mr-auto;
}

.content-right {
  @apply text-end ml-auto;
}

.content-center {
  @apply text-center mx-auto;
}

.accordion-container {
  @apply w-full relative;
}

.accordion-dropdowns {
  @apply w-full rounded-[12px] flex flex-col justify-start items-start gap-y-[8px];
}

.accordion-dropdowns .accordion-dropdown-item {
  @apply w-full h-auto bg-ui-gray-6 rounded-[12px];
}

.accordion-dropdowns .accordion-dropdown-item .accordion-dropdown-title-wrapper {
  @apply w-full h-auto relative px-[55px] py-20px block cursor-pointer;
}

.accordion-dropdowns .accordion-dropdown-item .accordion-dropdown-title-wrapper::before {
  content: '';
  @apply absolute top-[50%] left-[27px] w-[13px] h-[13px]; 
  transform: translateY(-50%);
  transition: all 0.4s ease;
  background-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/general-icons/icon-accordion-plus.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.accordion-dropdowns .accordion-dropdown-item.open .accordion-dropdown-title-wrapper::before {
  background-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/general-icons/icon-accordion-minus.svg');
}

.accordion-dropdowns .accordion-dropdown-item .accordion-dropdown-title-wrapper .accordion-dropdown-title {
  @apply font-poppins text-ui-gray-2 fs-1;
}

.accordion-dropdowns .accordion-dropdown-item .accordion-dropdown-inner {
  @apply max-h-[0] overflow-hidden px-[55px] flex flex-row justify-between items-start gap-x-[12px];
  transition: all 0.5s ease;
}

.accordion-dropdowns .accordion-dropdown-item.open .accordion-dropdown-inner {
  @apply max-h-[100vh] my-24px;
}

.accordion-dropdowns .accordion-dropdown-item .accordion-dropdown-inner .accordion-dropdown-inner-copy {
  @apply w-full h-0 overflow-hidden font-poppins text-ui-gray-1 fs-0 max-w-[85%];
  transition: all 0.5s ease;
}


.accordion-dropdowns .accordion-dropdown-item.open .accordion-dropdown-inner .accordion-dropdown-inner-copy {
  @apply w-full h-full font-poppins text-ui-gray-1 fs-0 max-w-[85%];
}

.accordion-dropdowns .accordion-dropdown-item .accordion-dropdown-inner .accordion-dropdown-inner-image {
  @apply w-full h-auto object-cover rounded-[12px] max-h-[100vh] ;
}
/* Animations */
@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1, .overlay2{
  @apply bg-white absolute w-full h-full top-0 left-0 z-30 opacity-50;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.accordion-container.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0s;
  }
  
.accordion-container.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .15s;
}

